// @ts-nocheck
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
// Project
import { selectState } from 'utils/reduxActions';
import { ReactReduxContext } from 'config/configureStore';
// material
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';

function ButtonWithLoader(props) {
  const loading = props.loaders[props.buttonId];

  return (
    <IconButton
      color={props.color || 'primary'}
      onClick={props.onClick}
      disabled={props.disabled || loading}
      className={props.className}
      size={props.size}
      dataset={{ ...props.dataset }}>
      {loading ? <CircularProgress size={15} /> : props.children}
    </IconButton>
  );
}

// ------------------ CONFIG CONTAINER ------------------

const withConnect = connect(selectState('app.loaders'), null, null, { context: ReactReduxContext });

export default compose(withRouter, withConnect)(ButtonWithLoader);
